import { defineComponentStyle } from "@/components/ui"

export const zStackStyle = defineComponentStyle({
  base: {
    gap: "lg",
    overflow: "hidden",
    position: "relative",
  },
})

export type ZStackStyle = typeof zStackStyle
